module.exports = __webpack_public_path__ + "img/teacher-sample-m-4.741f3d72.png";